import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import previewModal from '@/views/claim/demageManage/previewModal.vue';
import { isImage, isVideo } from '@/views/claim/demageManage/utils';
import { auditVedio, getVedioDetail } from './request';
export default {
  props: {
    id: {
      type: String,
      default: ''
    },
    examineVisible: {
      type: Boolean,
      default: false
    }
  },
  components: {
    previewModal
  },
  data() {
    return {
      videoList: [],
      formData: {
        status: undefined,
        rejectReason: ''
      },
      initStatus: 'pending',
      // formRules: {
      //   status: [{required: true, message: this.$t('请选择状态'), trigger: 'change'}]
      // },
      loading: false,
      previewVisible: false,
      previewSrc: '',
      currentPreviewIndex: 0,
      fileType: ''
    };
  },
  computed: {
    formRules() {
      return {
        status: [{
          required: true,
          message: this.$t('请选择状态'),
          trigger: 'change'
        }]
      };
    }
  },
  watch: {
    examineVisible(val) {
      if (val) {
        this.getVideoDetail();
      }
    }
  },
  methods: {
    cancelPre() {
      this.previewVisible = false;
      this.previewSrc = '';
      this.currentPreviewIndex = 0;
    },
    async getVideoDetail() {
      try {
        const res = await getVedioDetail({
          sceneId: this.id
        });
        // Determine media type based on file extension
        console.log('Media details:', res);
        this.videoList = res.mediaUrl.map(item => ({
          url: item,
          name: item.substring(item.lastIndexOf('/') + 1),
          type: this.getMediaType(item)
        }));
        this.formData.status = res.status === 'pending' ? undefined : res.status;
        this.initStatus = res.status;
        this.formData.rejectReason = res.rejectReason;
      } catch (error) {
        console.error('Failed to get media details:', error);
      }
    },
    getMediaType(url) {
      const extension = url.split('.').pop().toLowerCase();
      const videoExtensions = ['mp4', 'webm', 'ogg', 'mov'];
      const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'webp'];
      if (videoExtensions.includes(extension)) {
        return 'video';
      } else if (imageExtensions.includes(extension)) {
        return 'image';
      }
      return 'image'; // Default to image if extension is unknown
    },
    handleStatusChange(value) {
      this.formData.status = value;
      if (value === 'approved') {
        this.formData.rejectReason = '';
      }
    },
    async preview(file, index) {
      //文件预览 图片和视频弹窗预览 其他文件新打开页面
      this.fileType = '';
      let type = file.url.substring(file.url.lastIndexOf('.')).substring(1).toLowerCase();
      if (isImage(type)) {
        this.fileType = 'image';
      }
      if (isVideo(type)) {
        this.fileType = 'video';
      }
      if (this.fileType === 'image' || this.fileType === 'video') {
        this.previewSrc = file.url;
        this.currentPreviewIndex = index;
      }
      this.previewVisible = true;
    },
    handleConfirm() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          const params = {
            sceneId: this.id,
            status: this.formData.status,
            rejectReason: this.formData.rejectReason
          };
          this.loading = true;
          auditVedio(params).then(res => {
            console.log('Audit success:', res);
            this.$message.success(this.$t('操作成功'));
            this.$emit('update:examineVisible', false);
          }).finally(() => {
            this.loading = false;
          });
        }
      });
    },
    handleCancel() {
      this.$emit('update:examineVisible', false);
    }
  }
};